<script>
import { keydownWrapper } from '$lib/app/lib.js';

let {
    list = []
} = $props();

let hidden = $state(true);
    
//list = list.sort();  SVELTE5
const cut_list_after = 3;
let list_begin = list.slice(0, cut_list_after);   
let list_end = list.slice(cut_list_after);  

if(list_end?.length == 1) 
    list_begin.push(list_end.shift());

function toggle_hide(e) {
    e.preventDefault();
    hidden = !hidden;
}

</script>
<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<span role="button" tabindex=0 onkeydown={keydownWrapper(toggle_hide)} onclick={toggle_hide}>
{list_begin.join(", ")}{#if list_end?.length}, 
    {#if hidden}
        <span class="more-text">+{list_end?.length} more</span>
    {:else}
        <span class="less-text">{list_end.join(", ")}</span>
    {/if}
{/if}
</span>

<style>
.more-text {
    cursor: pointer;
    border-bottom: 1px dotted #000;
    text-decoration: none;
}

.less-text {
    cursor: pointer;
}
</style>
